module.exports = __webpack_public_path__ + "static/media/live-streaming-off.87060026.svg";